<template>
  <div>
    <div class="stepsdemo-content">
      <div class="card card-theme">
        <h3 class="card-title">
          Charity Information
        </h3>
        <h6 class="card-subtitle">
          Please enter the charities information
        </h6>
        <div class="client-card-footer">
          <div class="p-grid p-nogutter p-justify-between">
            <Button label="Back to List" @click="backToList()" icon="pi pi-angle-left"/>
            <Button v-if="(user_accesses && userService.hasAccess(user_accesses, ['admin', 'add_charity', 'edit_charity']))" label="Save & Next" @click="handleSubmit()" icon="pi pi-angle-right" iconPos="right"/>
            <Button v-else label="Next" @click="nextPage()" icon="pi pi-angle-right" iconPos="right"/>
          </div>
        </div>
      </div>
    </div>

    <div class="stepsdemo-content">
      <div class="card card-theme">
        <div class="p-grid nested-grid">
          <div class="p-col-12 p-lg-5">
            <h3 class="card-title">
              Charity Info
            </h3>

            <div class="p-grid">
              <div class="p-col-12">
                <div class="form-group">
                  <label for="name">Name</label>
                  <InputText type="text" v-model="name" id="name" class="form-control" :class="{ 'is-invalid': submitted && $v.name.$error }" />
                  <div v-if="submitted && !$v.name.required" class="invalid-feedback">Name is required</div>
                  <div v-if="submitted && !$v.name.minLength" class="invalid-feedback">Name must have at least {{$v.name.$params.minLength.min}} letters</div>
                </div>
              </div>
              <div class="p-col-12">
                <div class="form-group">
                  <label for="registration_number">Registration Number</label>
                  <InputText type="text" v-model="registration_number" id="registration_number" class="form-control" :class="{ 'is-invalid': submitted && $v.registration_number.$error }" />
                  <div v-if="submitted && !$v.registration_number.required" class="invalid-feedback">Registration number is required</div>
                </div>
              </div>
              <div class="p-col-12">
                <div class="form-group">
                  <label for="website">Website Address</label>
                  <InputText type="text" v-model="website" id="website" class="form-control" :class="{ 'is-invalid': submitted && $v.website.$error }" />
                  <div v-if="submitted && !$v.website.required" class="invalid-feedback">Website address is required</div>
                  <div v-if="submitted && !$v.website.url" class="invalid-feedback">Website address must be a url (e.g https://parkdonate.com)</div>
                </div>
              </div>
            </div>

            <div class="p-grid">

              <div class="p-col-12 p-md-12 p-lg-12">
                <span class="p-field">
                  <label for="description">Description</label>
                  <Textarea id="description" class="card-input" :autoResize="true" rows="5" cols="30"
                            v-model="description"/>
                </span>
              </div>
              
              <div class="p-col-12 p-md-12 p-lg-12">
                <label for="latitude">Address</label>
                <hr/>
              </div>
              
              <div class="p-col-6 p-lg-6">
                <div class="form-group">
                  <label for="latitude">Address 1</label>
                  <InputText type="text" v-model="address_obj.street_1" class="form-control" :class="{ 'is-invalid': submitted && $v.address_obj.street_1.$error }"/>
                  <div v-if="submitted && !$v.address_obj.street_1.required" class="invalid-feedback">Address 1 is required</div>
                </div>
              </div>

              <div class="p-col-6 p-lg-6">
                <div class="form-group">
                  <label for="latitude">Address 2 (Optional)</label>
                  <InputText type="text" v-model="address_obj.street_2" class="form-control" />
                </div>
              </div>

              <div class="p-col-6 p-lg-6">
                <div class="form-group">
                  <label for="latitude">City</label>
                  <InputText type="text" v-model="address_obj.city" class="form-control" :class="{ 'is-invalid': submitted && $v.address_obj.city.$error }"/>
                  <div v-if="submitted && !$v.address_obj.city.required" class="invalid-feedback">City is required</div>
                </div>
              </div>

              <div class="p-col-6 p-lg-6">
                <div class="form-group">
                  <label for="latitude">County (Optional)</label>
                  <InputText type="text" v-model="address_obj.county" class="form-control"/>
                </div>
              </div>

              <div class="p-col-6 p-lg-6">
                <div class="form-group">
                  <label for="latitude">Postal Code</label>
                  <InputText type="text" v-model="address_obj.postal_code" class="form-control" :class="{ 'is-invalid': submitted && $v.address_obj.postal_code.$error }"/>
                  <div v-if="submitted && !$v.address_obj.postal_code.required" class="invalid-feedback">Postal code is required</div>
                </div>
              </div>

              <div class="p-col-12 p-md-12 p-lg-12">
                <hr/>
              </div>

            </div>

          </div>
          <div class="p-col-12 p-lg-1">
          </div>

          <div class="p-col-12 p-lg-5">
            <h3 class="card-title">
              Contact Info
            </h3>

            <div class="p-grid">
              <div class="p-col-12">
                <div class="form-group">
                  <label for="contact_name">Contact Name</label>
                  <InputText type="text" v-model="contact_name" id="contact_name" class="form-control" :class="{ 'is-invalid': submitted && $v.contact_name.$error }" />
                  <div v-if="submitted && !$v.contact_name.required" class="invalid-feedback">Contact name is required</div>
                  <div v-if="submitted && !$v.contact_name.minLength" class="invalid-feedback">Contact name must have at least {{$v.contact_name.$params.minLength.min}} letters</div>
                </div>
              </div>
              <div class="p-col-12">
                <span class="p-field">
                  <label for="contact_job_title">Job title</label>
                  <InputText class="card-input" id="contact_job_title" type="text" v-model="contact_job_title"/>
                </span>
              </div>
              <div class="p-col-12">
                <div class="form-group">
                  <label for="contact_email">Email</label>
                  <InputText type="text" v-model="contact_email" id="contact_email" class="form-control" :class="{ 'is-invalid': submitted && $v.contact_email.$error }" />
                  <div v-if="submitted && !$v.contact_email.required" class="invalid-feedback">Email is required</div>
                  <div v-if="submitted && !$v.contact_email.email" class="invalid-feedback">Email is not valid</div>
                </div>
              </div>
              <div class="p-col-12">
                <div class="form-group">
                  <label for="contact_mobile">Mobile</label>
                  <InputText type="text" v-model="contact_mobile" id="contact_mobile" class="form-control" :class="{ 'is-invalid': submitted && $v.contact_mobile.$error }" />
                  <div v-if="submitted && !$v.contact_mobile.numeric" class="invalid-feedback">Mobile number must be numeric</div>
                  <div v-if="submitted && !$v.contact_mobile.minLength" class="invalid-feedback">Mobile number must have at least {{$v.contact_mobile.$params.minLength.min}} digits</div>
                </div>
              </div>
              <div class="p-col-12">
                <span class="p-field">
                  <label for="contact_landline">Landline</label>
                  <InputText class="card-input" id="contact_landline" type="text" v-model="contact_landline"/>
                </span>
              </div>
            </div>

          </div>
        </div>


      </div>
    </div>

  </div>
</template>

<script>
  import { required, minLength, numeric, email, url } from 'vuelidate/lib/validators'
  import UserService from '../../services/UserService';

  export default {
    props: {
      mode: {
        type: String,
        required: false,
        default: 'add'
      },
    },
    data() {
      return {
        name: '',
        address_obj: {street_1: "", street_2: "", city: "", postal_code: "", county: ""},
        registration_number: '',
        description: '',
        website: '',

        contact_name: '',
        contact_job_title: '',
        contact_email: '',
        contact_landline: '',
        contact_mobile: '',

        submitted: false,
        user_accesses: this.$store.state.accesses,
        userService: null,
      }
    },
    validations: {
      name: {
        required,
        minLength: minLength(2)
      },
      registration_number: {
        required
      },
      website: {
        required,
        url
      },
      address_obj: {
        street_1: {
          required
        },
        city: {
          required
        },
        postal_code: {
          required
        }
      },
      contact_name: {
        required,
        minLength: minLength(2), 
      },
      contact_email: {
        required,
        email
      },
      contact_mobile: {
        minLength: minLength(10),
        numeric 
      },
    },
    methods: {
      nextPage() {
        this.submitted = true;
        this.$emit('nextPage', {
          pageIndex: 0
        });
      },
      handleSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Validation failed!',
            detail: 'You can proceed after all marked fields are rectified',
            life: 5000
          });
          return;
        }

        let formData = {
            name: this.name,
            address_obj: this.address_obj,
            registration_number: this.registration_number,
            description: this.description,
            website: this.website,
            contact_name: this.contact_name,
            contact_job_title: this.contact_job_title,
            contact_email: this.contact_email,
            contact_landline: this.contact_landline,
            contact_mobile: this.contact_mobile,
            step: 'general_info'
        }

        this.$emit('complete', {
          formData: formData,
          pageIndex: 0
        });
      },
      backToList() {
        this.$router.push('/charities').catch()
      }
    },
    created() {
      this.userService = new UserService();
      if (!this.user_accesses) {
        let user_info = this.$store.state.user_info ? JSON.parse(this.$store.state.user_info) : {};
        this.userService.getUserAccesses(user_info.id).then(result => {
          if (result.status === 200) {
            let accesses = result.data.accesses;
            this.$store.state.accesses = accesses;
            this.user_accesses = accesses;
          }
        });
      }
    },
    mounted() {
      let charity_info = localStorage.getItem("charity_info");
      if (charity_info) {
        charity_info = JSON.parse(charity_info);
        this.name = charity_info.name;
        this.address_obj = charity_info.address_obj;
        this.registration_number = charity_info.registration_number;
        this.description = charity_info.description;
        this.website = charity_info.website;
        this.contact_name = charity_info.contact_name;
        this.contact_email = charity_info.contact_email;
        this.contact_job_title = charity_info.contact_job_title;
        this.contact_landline = charity_info.contact_landline;
        this.contact_mobile = charity_info.contact_mobile;
        this.mode = 'edit';
      }
    },
  }
</script>

<style scoped>
  .card-subtitle {
    margin: 0;
    margin-bottom: 3em;
  }

  .card-title {
    margin-bottom: 0.5em;
    font-weight: bold;
  }

  .card-input {
    width: 100%;
    margin-bottom: 1rem;
  }
</style>